import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { SourcingFulfillmentStatus } from '../../enums';
import { BaseEntity } from './base.entity';
import { OrderDetailEntity } from './order-detail.entity';
import { PurchaseOrderDetailEntity } from './purchase-order-detail.entity';
import { SourcingRequestLineEntity } from './sourcing-request-line.entity';

@Index('idx_sfa_od', ['fkOrderDetailId'], {})
@Index('idx_sfa_srl', ['fkSourcingRequestLineId'], {})
@Index('idx_sfa_pod', ['fkPurchaseOrderDetailId'], {})
@Index('idx_sfa_status', ['status'], {})
@Entity('sourcing_fulfillment_allocation')
export class SourcingFulfillmentAllocationEntity extends BaseEntity {
	@Column('int', { name: '_fk_order_detail__id', unsigned: true })
	public fkOrderDetailId!: number;

	@Column('int', {
		name: '_fk_sourcing_request_line__id',
		nullable: true,
		unsigned: true,
	})
	public fkSourcingRequestLineId!: number | null;

	@Column('int', {
		name: '_fk_purchase_order_detail__id',
		nullable: true,
		unsigned: true,
	})
	public fkPurchaseOrderDetailId!: number | null;

	@Column('decimal', {
		name: 'quantity_allocated',
		precision: 15,
		scale: 4,
		default: 0,
	})
	public quantityAllocated!: number;

	@Column('decimal', {
		name: 'quantity_received',
		precision: 15,
		scale: 4,
		default: 0,
	})
	public quantityReceived!: number;

	@Column('decimal', {
		name: 'quantity_fulfilled',
		precision: 15,
		scale: 4,
		default: 0,
	})
	public quantityFulfilled!: number;

	@Column('enum', {
		name: 'status',
		enum: SourcingFulfillmentStatus,
		default: SourcingFulfillmentStatus.PENDING,
	})
	public status!: SourcingFulfillmentStatus;

	@ManyToOne(() => OrderDetailEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_order_detail__id', referencedColumnName: 'id' }])
	public fkOrderDetail!: OrderDetailEntity;

	@ManyToOne(
		() => SourcingRequestLineEntity,
		(line) => line.fulfillmentAllocations,
		{
			onDelete: 'SET NULL',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([
		{ name: '_fk_sourcing_request_line__id', referencedColumnName: 'id' },
	])
	public fkSourcingRequestLine!: SourcingRequestLineEntity | null;

	@ManyToOne(() => PurchaseOrderDetailEntity, {
		onDelete: 'SET NULL',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([
		{ name: '_fk_purchase_order_detail__id', referencedColumnName: 'id' },
	])
	public fkPurchaseOrderDetail!: PurchaseOrderDetailEntity | null;
}
